import { TMessageAdditionalInfo } from '@cockpitai/components/organisms/Chat/types'

import { create } from 'zustand'

type TItemListGraphic = {
  position: 1
  title: string
  value: number
}

type TGraphic = {
  type: 'list'
  dateRef: 'string'
  items: TItemListGraphic[]
}

export type MessageType = {
  id?: number
  type: 'user' | 'answer' | 'nps'
  message: string
  like?: boolean
  likeText?: string
  datetime: string
  example?: 1 | 2 | 3 | 4
  graphic?: TGraphic
  chatId?: number
  additional_info?: TMessageAdditionalInfo[]
  animation?: boolean
  score?: number
  scoreText?: string
  ratingText?: string
}

interface ChatState {
  currentChatId?: number
  currentStdCode?: string
  messages: MessageType[]
  isStarted: boolean
  isLoading: boolean
  historyChatId?: number
  setIsLoading: (isLoading: boolean) => void
  setIsStartedChat: (isStarted: boolean) => void
  clearMessages: () => void
  newMessage: (newMessage: MessageType) => void
  setInitialMessages: (messages: MessageType[]) => void
  setChatId: (historyChatId: number) => void
  setCurrentStdCode: (currentStdCode: string) => void
  setOffAnimation: () => void
}

const initialState = {
  currentStdCode: undefined,
  messages: [],
  isStarted: false,
  isLoading: false,
}

export const useChatStore = create<ChatState>((set) => {
  return {
    ...initialState,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),
    setCurrentStdCode: (currentStdCode: string) => set({ currentStdCode }),
    setIsStartedChat: (isStarted: boolean) => set({ isStarted }),
    setChatId: (historyChatId: number) => set({ historyChatId }),
    newMessage: (newMessage: MessageType) => {
      set((state) => {
        return {
          messages: [
            ...state.messages,
            {
              ...newMessage,
            },
          ],
        }
      })
    },
    setOffAnimation: () => {
      set((state) => {
        if (state.messages.length === 0) return state

        const updatedMessages = [...state.messages]

        updatedMessages[updatedMessages.length - 1] = {
          ...updatedMessages[updatedMessages.length - 1],
          animation: false,
        }

        return {
          messages: updatedMessages,
        }
      })
    },
    setInitialMessages: (messages: MessageType[]) => {
      set({ messages })
    },
    clearMessages: () => {
      set({ messages: [], historyChatId: undefined })
    },
  }
})
